module.exports = __webpack_public_path__ + "img/create-wallet-m-1-en.e3b0dd1f.png";